import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=1bac1254&scoped=true&"
import script from "./AppForm.vue?vue&type=script&lang=ts&"
export * from "./AppForm.vue?vue&type=script&lang=ts&"
import style0 from "./AppForm.vue?vue&type=style&index=0&id=1bac1254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bac1254",
  null
  
)

export default component.exports